/**
 * Generic Field class with basic logic
 */
class Field {
  /**
   * Creates random string for inputs ID attribute
   * @param len {number} Length of string
   * @returns {string}
   */
  static createRandomID(len = 24) {
    let str = "",
      i = 0,
      min = 10,
      max = 62;

    while (i < len) {
      let r = (Math.random() * (max - min) + min) << 0;
      str += String.fromCharCode((r += r > 9 ? (r < 36 ? 55 : 61) : 48));
      i += 1;
    }
    return str;
  }

  init() {}

  /**
   * Parse answer tags from object to string of IDs
   * @param tags
   */
  static parseTags(tags) {
    return tags
      .map((el) => {
        return el.id;
      })
      .join(",");
  }

  /**
   * Get first reply from array of replies if they exists
   * @returns {{name: string, value: string, type}}
   */
  get reply() {
    return typeof this.replies != "undefined" && this.replies.length > 0
      ? this.replies[0]
      : { name: "reply", value: "", type: this.question.type };
  }

  /**
   * Get array of replies
   * @returns {{name: string, value: string, type}|Array|*}
   */
  get replies() {
    return this.question.reply;
  }

  constructor(question) {
    this.question = question;

    this.validator = Validator.validator();
    this.assert = Validator.Assert;
  }

  /**
   * Insert fields HTML to answer scaffold
   * @param fields {Array<string>|string} valid HTML
   * @returns {string} valid HTML
   */
  render(fields) {
    let htmlElements = [
      `<div class="${this.question.type} elastic-answer">`,
      `<div class="available_answers">`,
    ];

    if (Array.isArray(fields)) {
      fields = fields.join("");
    }

    htmlElements.push(fields);
    htmlElements.push("</div>");

    if (this.question.allow_custom === true) {
      htmlElements.push(this._manageCustomAnswer());
    }

    htmlElements.push("</div>");

    $("#elastic-modal").scrollTop(0);
    return htmlElements.join("");
  }

  /**
   * Perform validation of give field with given rules and with validation message
   *
   * @param field {string|Object|boolean}
   * @param rules {Array<assert>} Validator.js Asserts
   * @param validationMessage {string}
   * @returns {{status: boolean, message: (string|null)}}
   */
  validate(field, rules = [], validationMessage) {
    let result = { status: true, message: null };

    if (field !== true && (field || (!field && !this.question.optional))) {
      result.status =
        field === false
          ? false
          : this.validator.validate(field, rules) === true; // cast to boolean
      result.message = result.status
        ? null
        : this.question.validation_message || validationMessage;
    }

    // skip custom validation if predefined answer is invalid
    // this prevent to override validation message
    if (result.status) {
      result = this._customFieldValidate(result);
      result = this._validationBudgetPerPersonField(result);
    }

    return result;
  }

  /**
   * Takes regular validation result, and override with validation
   * of custom answer field.
   * @param result
   * @returns {*}
   * @private
   */
  _customFieldValidate(result) {
    let custom = this.replies.filter(function (element) {
      return element.type == "custom_answer";
    });

    if (custom.length > 0) {
      switch (this.question.custom_validation) {
        case "numeric":
          result.status = /^[1-9]\d*$/.test(custom[0].value);
          result.message =
            status === true
              ? null
              : "Wpisz poprawną liczbę, bez przecinka lub zaznacz jedną z dostępnych odpowiedzi.";
          break;

        case "alphanumeric":
          result.status = /[a-z0-9]+/.test(custom[0].value);
          result.message =
            status === true
              ? null
              : "Wpisz swoją odpowiedź zawierającą tylko litery i cyfry lub zaznacz jedną z dostępnych odpowiedzi.";
          break;

        case "alphanumeric-only":
          result.status = /^[a-z0-9]+$/.test(custom[0].value);
          result.message =
            status === true
              ? null
              : "Wpisz swoją odpowiedź zawierającą tylko litery i cyfry lub zaznacz jedną z dostępnych odpowiedzi.";
          break;

        case "firstname-surname":
          result.status =
            /^(?![-\s]+$)[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ\s-]{1,50}$/.test(
              custom[0].value
            );
          result.message =
            status === true
              ? null
              : "Wpisz swoją odpowiedź zawierającą tylko litery i spacje.";
          break;

        default:
          result.status =
            this.validator.validate(custom[0].value, [
              this.assert.NotBlank(),
            ]) === true; // cast to boolean
          result.message = result.status
            ? null
            : "Wpisz swoją odpowiedź lub odznacz to pole";
          break;
      }
    }

    return result;
  }

  _validationBudgetPerPersonField(result) {
    let custom = this.replies.filter(function (element) {
      return element.type == "custom_answer";
    });

    if (
      custom.length > 0 &&
      this.question.handler === "brief_budget_per_person_handler"
    ) {
      if (custom[0].value < 25 || custom[0].value > 9999) {
        result.status = false;
        result.message = "Wprowadź prawidłową liczbę z przedziału 25 - 9999.";
      }
    }

    return result;
  }

  /**
   * If custom answer should be rendered attach it at the end of question
   * @returns {string}
   * @private
   */
  _manageCustomAnswer() {
    let nameAttr = Field.createRandomID(5),
      type = {
        multiple: "checkbox",
        single: "radio",
        s_image: "radio",
        m_image: "checkbox",
      },
      isChecked = "",
      isValue = "";

    if (this.replies.length > 0) {
      /*
       * first reply is regular reply object
       * second reply is an input name
       */
      let custom = this.replies.filter((el) => {
        return el.type === "custom_answer";
      });

      isChecked = custom.length > 0 ? 'checked="checked"' : "";
      isValue = isChecked ? custom[0].value : "";
    }

    return `<div class="custom_answers">
                   <div class="${type[this.question.type]}">
                       <input type="${type[this.question.type]}"
                              id="allow_custom${this.question.id}"
                              class="allow_custom"
                              name="reply:${nameAttr}"
                              ${isChecked}
                              data-origin="custom"
                              autocomplete="off">
                       <label for="allow_custom${this.question.id}"></label>
                   </div>
                   <div class="custom_answer elastic-answer">
                       <input type="text"
                              name="custom_answer"
                              class="form-control"
                              data-tags=""
                              placeholder="${
                                this.question.custom_placeholder || ""
                              }"
                              value="${isValue}"
                              autocomplete="off">
                   </div>
               </div>`;
  }
}

/**
 * SingleChoiceFiled rendered as inputs type radio
 */
class SingleChoiceField extends Field {
  get type() {
    return "radio";
  }

  //noinspection JSCheckFunctionSignatures
  /**
   * Renders form's choice field
   * @returns {string} valid HTML
   */
  render() {
    let fields = [],
      nameAttr = Field.createRandomID(5);

    this.question.available_answers.forEach((element) => {
      let id = Field.createRandomID(),
        tags = Field.parseTags(element.tags),
        isChecked = "";

      try {
        isChecked =
          this.replies.findIndex(function (el) {
            let v = el.value;
            let e = element.value;

            if (typeof e == "string") {
              e = e.trim().toLowerCase();
            }

            if (typeof v == "string") {
              v = v.trim().toLowerCase();
            }
            return v == e;
          }) >= 0
            ? 'checked="checked"'
            : "";
      } catch (err) {
        isChecked = "";
      }

      fields.push(`
                <input type="${this.type}"
                       name="reply:${nameAttr}"
                       value="${element.value}"
                       id="${id}"
                       data-answer-id="${element.id}"
                       data-tags="${tags}"
                       ${isChecked}
                       data-origin="available"
                       autocomplete="off">
                <label for="${id}">${element.label}</label>
            `);
    });

    return super.render(fields);
  }

  //noinspection JSCheckFunctionSignatures
  /**
   * Perform choices validation
   * @returns {{status: boolean, message: (string|null)}}
   */
  validate() {
    return super.validate(
      this.replies.length > 0,
      [this.assert.EqualTo(true)],
      "Zaznacz minimum jedną odpowiedź"
    );
  }
}

class SingleImageChoiceField extends Field {
  get type() {
    return "radio";
  }

  static generateCloudinaryUrl(base_url, width, height, crop) {
    let images_url = ElasticForm.config.images_url;
    return `${images_url}/image/upload/${crop},w_${width},h_${height}/${base_url}`;
  }

  init() {
    $(".answer-image").click(function (event) {
      let that = $(this);
      $(".answer-image-container.checked").removeClass("checked");
      that.parents(".answer-image-container").toggleClass("checked");
      SingleImageChoiceField.toggleInput(that);

      that
        .closest(".elastic-answer")
        .find(".custom_answers")
        .find('input[type="radio"]')
        .prop("checked", false)
        .end()
        .find('input[type="text"]')
        .val("");
    });
    $(".custom_answers input[type='radio']").click(function () {
      $(".answer-image-container.checked").removeClass("checked");
    });
  }

  static toggleInput(imageObj) {
    let inputId = imageObj.data("input-id");
    let input = $(`#${inputId}`);
    input.prop("checked", true);
  }

  isChecked(replies, element) {
    return (
      replies.findIndex(function (el) {
        let v = el.value;
        let e = element.value;

        if (typeof e == "string") {
          e = e.trim().toLowerCase();
        }

        if (typeof v == "string") {
          v = v.trim().toLowerCase();
        }
        return v == e;
      }) >= 0
    );
  }

  //noinspection JSCheckFunctionSignatures
  /**
   * Renders form's choice field
   * @returns {string} valid HTML
   */
  render() {
    let fields = [],
      nameAttr = Field.createRandomID(5);

    this.question.available_answers.forEach((element) => {
      let id = Field.createRandomID(),
        tags = Field.parseTags(element.tags),
        isChecked = "",
        image_url = SingleImageChoiceField.generateCloudinaryUrl(
          element.image,
          160,
          160,
          "c_crop"
        ),
        isCheckedAttr,
        isCheckedClass;

      isChecked = this.isChecked(this.replies, element);
      if (isChecked) {
        isCheckedAttr = isChecked ? 'checked="checked"' : "";
        isCheckedClass = " checked";
      } else {
        isCheckedAttr = "";
        isCheckedClass = "";
      }

      fields.push(`
                <div class="answer-image-container">
                <input type="${this.type}"
                       name="reply:${nameAttr}"
                       value="${element.value}"
                       id="${id}"
                       data-answer-id="${element.id}"
                       data-tags="${tags}"
                       ${isCheckedAttr}
                       data-origin="available"
                       autocomplete="off"
                       hidden="true">

            <div class="image__wraper"><img class="answer-image ${isCheckedClass}" data-input-id="${id}" src="${image_url}" /></div>
            <label for="${id}">${element.label}</label></div>
            
            
            `);
    });
    return super.render(fields);
  }

  //noinspection JSCheckFunctionSignatures
  /**
   * Perform choices validation
   * @returns {{status: boolean, message: (string|null)}}
   */
  validate() {
    return super.validate(
      this.replies.length > 0,
      [this.assert.EqualTo(true)],
      "Zaznacz minimum jedną odpowiedź"
    );
  }
}

/**
 * MultipleImageChoiceField rendered as clickable images,
 * sets hidden checkboxes underneath
 */
class MultipleChoiceField extends SingleChoiceField {
  get type() {
    return "checkbox";
  }
}
/**
 *
 */
class MultipleImageChoiceField extends SingleImageChoiceField {
  get type() {
    return "checkbox";
  }

  init() {
    $(".answer-image-container.checked").removeClass("checked");

    $(".answer-image").click(function (event) {
      let that = $(this);
      that.parents(".answer-image-container").toggleClass("checked");
      MultipleImageChoiceField.toggleInput(that);
    });
  }

  static toggleInput(imageObj) {
    let inputId = imageObj.data("input-id");
    let input = $(`#${inputId}`);
    input.click();
  }
}

/**
 * TextField rendered as input type text
 */
class TextField extends Field {
  get type() {
    return "text";
  }

  //noinspection JSCheckFunctionSignatures
  /**
   * Renders form's text field
   * @returns {string} valid HTML
   */
  render() {
    let field = `<div class="${this.question.type} elastic-answer">
                         <input type="${this.type}"
                                name="reply"
                                class="form-control"
                                data-tags=""
                                value="${this.reply.value}"
                                data-origin="predefined"
                                autocomplete="off">
                     </div>`;

    return super.render(field);
  }

  /**
   * Perform text field validation
   * @param field
   * @param rules
   * @param validationMessage
   * @returns {{status: boolean, message: (string|null)}}
   */
  validate(
    field = this.reply.value,
    rules = [this.assert.NotBlank(), this.assert.isString()],
    validationMessage = "To pole nie może być puste"
  ) {
    return super.validate(field, rules, validationMessage);
  }
}

/**
 * LongTextField rendered as input type text
 */
class LongTextField extends Field {
  //noinspection JSCheckFunctionSignatures
  /**
   * Renders form's text field
   * @returns {string} valid HTML
   */
  render() {
    let field = `<div class="${this.question.type} elastic-answer">
                         <textarea
                                name="reply"
                                class="form-control"
                                data-tags=""
                                data-origin="predefined"
                                autocomplete="off">${this.reply.value}</textarea>
                     </div>`;

    return super.render(field);
  }

  /**
   * Perform text field validation
   * @param field
   * @param rules
   * @param validationMessage
   * @returns {{status: boolean, message: (string|null)}}
   */
  validate(
    field = this.reply.value,
    rules = [this.assert.NotBlank(), this.assert.isString()],
    validationMessage = "To pole nie może być puste"
  ) {
    return super.validate(field, rules, validationMessage);
  }
}

class FirstAndSurnameField extends TextField {
  get type() {
    return "text";
  }

  /**
   * Perform first and surname field validation
   * @param field
   * @param rules
   * @param validationMessage
   * @returns {{status: boolean, message: (string|null)}}
   */
  validate(
    field = /^(?![-\s]+$)[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ\s-]{1,50}$/.test(
      this.reply.value
    ),
    rules = [this.assert.EqualTo(true)],
    validationMessage = "Wprowadź poprawne imie i nazwisko"
  ) {
    return super.validate(field, rules, validationMessage);
  }
}

class NumberField extends TextField {
  get type() {
    return "number";
  }

  /**
   * Perform number field validation
   * @param field
   * @param rules
   * @param validationMessage
   * @returns {{status: boolean, message: (string|null)}}
   */
  validate(
    field = /^-?\d+([.,]\d+)?$/.test(this.reply.value),
    rules = [this.assert.EqualTo(true)],
    validationMessage = "Wprowadź wartość numeryczną"
  ) {
    return super.validate(field, rules, validationMessage);
  }
}

class EmailField extends TextField {
  get type() {
    return "email";
  }

  /**
   * Perform email field validation
   * @param field
   * @param rules
   * @param validationMessage
   * @returns {{status: boolean, message: (string|null)}}
   */
  validate(
    field = this.reply.value,
    rules = [this.assert.NotBlank(), this.assert.Email()],
    validationMessage = "Wprowadź poprawny adres email"
  ) {
    return super.validate(field, rules, validationMessage);
  }
}

class PhoneField extends TextField {
  get type() {
    return "tel";
  }

  /**
   * Perform phone field validation
   * @param field
   * @param rules
   * @param validationMessage
   * @returns {{status: boolean, message: (string|null)}}
   */
  validate(
    field = this.reply.value,
    rules = [this.assert.NotBlank(), this.assert.Tel()],
    validationMessage = "Wprowadź poprawny numer telefonu"
  ) {
    return super.validate(field, rules, validationMessage);
  }
}

/**
 * PermissionField rendered as input type text
 */
class PermissionField extends Field {
  get type() {
    return "checkbox";
  }

  //noinspection JSCheckFunctionSignatures
  /**
   * Renders form's text field
   * @returns {string} valid HTML
   */
  render() {
    let checked = this.reply.value == "on" ? 'checked="checked"' : "";
    let field = `<div class="${this.question.type} elastic-answer">
                         <input type="${this.type}"
                                name="reply"
                                class="form-control"
                                id="permission_${this.question.id}"
                                data-tags=""
                                data-origin="predefined"
                                ${checked}>
                        <label for="permission_${this.question.id}">${this.question.content}</label>
                     </div>`;

    return super.render(field);
  }

  /**
   * Perform text field validation
   * @param field
   * @param rules
   * @param validationMessage
   * @returns {{status: boolean, message: (string|null)}}
   */
  validate(
    field = this.reply.value,
    rules = [this.assert.NotBlank(), this.assert.isString()],
    validationMessage = "Ta zgoda jest wymagana"
  ) {
    return super.validate(field, rules, validationMessage);
  }
}

class DatetimeField extends Field {
  static get selector() {
    return "datepicker";
  }

  init() {
    moment.locale("en", {
      week: { dow: 1 }, // Monday is the first day of the week
      months: [
        "Styczeń",
        "Luty",
        "Marzec",
        "Kwiecień",
        "Maj",
        "Czerwiec",
        "Lipiec",
        "Sierpień",
        "Wrzesień",
        "Pażdziernik",
        "Listopad",
        "Grudzień",
      ],
      weekdaysMin: ["Ni", "Po", "Wt", "Śr", "Cz", "Pi", "So"],
    });

    $(`.${DatetimeField.selector}`).each(function () {
      let picker = $(this),
        defaultDate = picker.find("input").val();

      picker.datetimepicker({
        inline: true,
        sideBySide: true,
        format: "YYYY-MM-DD",
        minDate: moment().startOf("day"),
        stepping: 15,
        useCurrent: false,
        keepOpen: true,
        defaultDate: defaultDate ? defaultDate : false,
      });
    });
  }

  //noinspection JSCheckFunctionSignatures
  /**
   * Renders form's datetime picker field
   * @returns {string} valid HTML
   */
  render() {
    let field = `<div class="${this.question.type} elastic-answer">
                            <div class="${DatetimeField.selector} date">
                                <input type="text"
                                    name="reply"
                                    class="form-control hidden"
                                    data-tags=""
                                    value="${this.reply.value}"
                                    data-origin="predefined">
                            </div>
                     </div>`;

    return super.render(field);
  }

  //noinspection JSCheckFunctionSignatures
  /**
   * Perform datetime field validation
   * @returns {{status: boolean, message: (string|null)}}
   */
  validate() {
    //noinspection ES6ModulesDependencies,JSUnresolvedFunction
    return super.validate(
      moment(this.reply.value).isValid(),
      [this.assert.EqualTo(true)],
      "Wybierz datę"
    );
  }
}

function geoLoc() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function (position) {
      initMap(position.coords.latitude, position.coords.longitude);
      $("#lat").val(position.coords.latitude);
      $("#lng").val(position.coords.longitude);
      $(".radius-change").css("display", "block");

      let nice_lat = position.coords.latitude.toFixed(6);
      let nice_lng = position.coords.longitude.toFixed(6);
      let position_str = nice_lat + ", " + nice_lng;
      $("#pac-input").val(position_str);
    });
  } else {
    $(".elastic-question").append(
      "<span class='center-block validation-error'>" +
        "Nie jesteśmy w stanie pobrać Twojej lokalizacji. Wpisz samodzielnie miasto lub dzielnicę" +
        "</span>"
    );
  }
}

class MapField extends Field {
  static get selector() {
    return "elastic-map";
  }

  init(props) {
    let that = this,
      inputLat = $('input[name="area_latitude"]'),
      inputLng = $('input[name="area_longitude"]'),
      inputRadius = $('input[name="area_radius"]'),
      inputName = $('input[name="area_name"]'),
      clearButton = $('button.clear-button');
    
    inputName.focus();

    function updateClearButtonState() {
      if (inputName.val().length > 0) {
        clearButton.addClass('show');
      } else {
        clearButton.removeClass('show');
      }
    }

    inputName.on('input', updateClearButtonState);

    // Handle click event for the clear button
    clearButton.on('click', () => {
      inputName.val('');
      inputLat.val('');
      inputLng.val('');
      inputRadius.val('');
      document.getElementById(MapField.selector).innerHTML = '<div id="before-map"><p>Po wybraniu obszaru pojawi się mapa</p></div>';
      $(".radius-change-container").css("display", "none");

      const popularCitiesContainer = document.querySelector(".popular-cities-container");
      if (popularCitiesContainer) {
        popularCitiesContainer.style.display = "flex";
      } 
      clearButton.removeClass('show');
    });

    //noinspection JSUnresolvedVariable,Eslint
    let options = {
        fields: ["geometry", "types"],
        componentRestrictions: { country: "pl" },
        types: ["geocode"], //["(regions)"]
      },
      autocomplete = new google.maps.places.Autocomplete(inputName[0], options),
      autocompleteService = new google.maps.places.AutocompleteService();

    autocomplete.addListener("place_changed", function () {
      let place = autocomplete.getPlace();
      if (typeof place.geometry == "undefined") {
        return;
      }
      let placeLat = place.geometry.location.lat();
      let placeLng = place.geometry.location.lng();

      let predictedInputRadius = props.default_area_radius || 2880;
      // reduce radius if the place is closest neighborhood
      if (
        place.types.indexOf("neighborhood") > -1 ||
        place.types.indexOf("route") > -1
      ) {
        predictedInputRadius = 1440;
      }

      // set values
      inputLat.val(placeLat);
      inputLng.val(placeLng);
      inputRadius.val(predictedInputRadius);

      updateClearButtonState();
      that.drawMap();
      document.querySelector(".popular-cities-container").style.display = "none"; 
    });

    // prevent default action (validate) when enter is pressed for autocomplete
    inputName.keypress(function (event) {
      if (event.which == 13) {
        event.preventDefault();
      }
    });

    if (props.map_search_help_text) {
      inputName.attr("placeholder", props.map_search_help_text);
    } else {
      inputName.attr("placeholder", "Wpisz miasto lub dzielnicę");
    }

    $("#enlarge-area-btn").click(function (event) {
      that.resizeArea(2);
    });

    $("#reduce-area-btn").click(function (event) {
      that.resizeArea(0.5);
    });

    document.querySelectorAll(".btn-popular-city").forEach((button) => {
      button.addEventListener("click", () => {
        const city = button.innerText;
        inputName.value = city;

        autocompleteService.getPlacePredictions(
          {
            input: city,
            componentRestrictions: { country: "pl" },
            types: ["geocode"],
          },
          (predictions, status) => {
            if (
              status === google.maps.places.PlacesServiceStatus.OK &&
              predictions &&
              predictions.length > 0
            ) {
              const placeId = predictions[0].place_id;
              const placesService = new google.maps.places.PlacesService(
                document.createElement("div")
              );

              placesService.getDetails(
                {
                  placeId: placeId,
                  fields: ["geometry", "name"],
                },
                (place, status) => {
                  if (
                    status === google.maps.places.PlacesServiceStatus.OK &&
                    place &&
                    place.geometry &&
                    place.geometry.location
                  ) {
                    inputLat.val(place.geometry.location.lat());  
                    inputLng.val(place.geometry.location.lng()); 
                    inputRadius.val(2880);  
                    inputName.val(place.name);
                    updateClearButtonState();

                    that.drawMap();
                    document.querySelector(".popular-cities-container").style.display = "none"; 
                  }
                }
              );
            }
          }
        );
      });
    });
      
    // draw map if latitude and longitude is already set
    if (inputLat.val() != "" && inputLng.val() != "") {
      that.drawMap();
    }
  }

  resizeArea(modifier) {
    let inputRadius = $('input[name="area_radius"]') || 2880;
    let radius = parseFloat(inputRadius.val());
    let newRadius = radius * modifier;
    if (newRadius > 180 && newRadius < 92200) {
      inputRadius.val(newRadius);
      this.drawMap();
    }
  }

  drawMap() {
    let inputLat = $('input[name="area_latitude"]'),
      inputLng = $('input[name="area_longitude"]'),
      inputRadius = $('input[name="area_radius"]');
    //noinspection JSUnresolvedVariable,Eslint
    let lat = parseFloat(inputLat.val()) || 52.220819,
      lng = parseFloat(inputLng.val()) || 21.015775,
      zoom = 13,
      areaRadius = parseInt(inputRadius.val()) || 2880;

    let map = new google.maps.Map(document.getElementById(MapField.selector), {
      zoom: zoom,
      center: {
        lat: lat,
        lng: lng,
      },
      keyboardShortcuts: false,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      disableDefaultUI: true,
      gestureHandling: "none",
      scrollwheel: false,
      draggableCursor: "no-dropp",
      styles: [
        {
          featureType: "poi",
          elementType: "labels",
          stylers: [{ visibility: "off" }],
        },
      ],
    });

    let area = new google.maps.Circle({
      strokeColor: "#FF0000",
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "#FF0000",
      fillOpacity: 0.35,
      map: map,
      center: { lat: lat, lng: lng },
      radius: areaRadius,
    });
    let visibleArea = new google.maps.Circle({
      strokeColor: "#04b600",
      strokeOpacity: 0,
      strokeWeight: 2,
      fillColor: "#39ff0d",
      fillOpacity: 0,
      map: map,
      center: { lat: lat, lng: lng },
      radius: areaRadius * 0.8,
    });
    let bounds = new google.maps.LatLngBounds();
    bounds.extend(area.center);

    let visibleAreBounds = visibleArea.getBounds().toJSON();
    bounds.extend({ lng: visibleAreBounds.west, lat: visibleAreBounds.south });
    bounds.extend({ lng: visibleAreBounds.east, lat: visibleAreBounds.north });

    map.fitBounds(bounds);

    $(".radius-change-container").css("display", "flex");
  }

  //noinspection JSCheckFunctionSignatures
  /**
   * Renders form's google map field
   * @returns {string} valid HTML
   */
  render() {
    let mapElements = this._parseMapElements();

    let field = `
                    <!--<div onclick="geoLoc();" class="my_local">-->
                        <!--<img src="/static/project/src/img/my_location.png" alt="my location">-->
                        <!--<span>Wykorzystaj moją lokalizację</span>-->
                    <!--</div>-->
                    <div class="map-question-container">

                        <input type="hidden"
                                name="area_latitude"
                                id="lat"
                                data-origin="predefined"
                                data-tags=""
                                value="${mapElements.area_latitude.value}"/>
                         <input type="hidden"
                                name="area_longitude"
                                id="lng"
                                data-origin="predefined"
                                data-tags=""
                                value="${mapElements.area_longitude.value}"
                                />
                        <input type="hidden"
                                name="area_radius"
                                id="radius"
                                data-origin="predefined"
                                value="${mapElements.area_radius.value}"
                                data-tags="" />

                        <div id="map-question">
                            <div class="map-input-wrapper">
                              <input type="text"
                                    name="area_name"
                                    id="area-name-input"
                                    data-origin="predefined"
                                    class="controls form-control"
                                    value="${mapElements.area_name.value}"
                                    placeholder="start"/>
                              <button type="button" class="clear-button">&#x2716;</button>
                            </div>
                        </div>
                        <div class="popular-cities-container">
                          <button type="button" class="btn btn-popular-city">
                              Warszawa
                          </button>
                           <button type="button" class="btn btn-popular-city">
                              Kraków
                          </button>
                           <button type="button" class="btn btn-popular-city">
                              Wrocław
                          </button>
                           <button type="button" class="btn btn-popular-city">
                              Łódź
                          </button>
                        </div>
                        <div class="radius-change-container">
                            <button type="button" class="btn btn-radius-change" id="reduce-area-btn">
                                Zmniejsz obszar
                            </button>
                            <button type="button" class="btn btn-radius-change" id="enlarge-area-btn">
                                Zwiększ obszar
                            </button>
                        </div>
                        <div id="${MapField.selector}" style="height: 320px">
                            <div id="before-map">
                                <p>Po wybraniu obszaru pojawi się mapa</p>
                            </div>
                        </div>
                    </div>
                    `;

    return super.render(field);
  }

  //noinspection JSCheckFunctionSignatures
  /**
   * Perform map field validation
   * @returns {{status: boolean, message: (string|null)}}
   */
  validate() {
    let mapElements = this._parseMapElements(),
      validations =
        this.validator.validate(mapElements.area_latitude.value, [
          this.assert.NotBlank(),
        ]) &&
        this.validator.validate(mapElements.area_longitude.value, [
          this.assert.NotBlank(),
        ]);

    return super.validate(
      validations,
      [this.assert.EqualTo(true)],
      "Wpisz miasto lub dzielnicę, aby wybrać obszar"
    );
  }

  _parseMapElements() {
    let area_latitude = this.replies.filter((el) => {
        return el.name == "area_latitude";
      }),
      area_longitude = this.replies.filter((el) => {
        return el.name == "area_longitude";
      }),
      zoom = this.replies.filter((el) => {
        return el.name == "zoom";
      }),
      area_radius = this.replies.filter((el) => {
        return el.name == "area_radius";
      }),
      area_name = this.replies.filter((el) => {
        return el.name == "area_name";
      });

    area_latitude = area_latitude.length > 0 ? area_latitude[0] : { value: "" };
    area_longitude =
      area_longitude.length > 0 ? area_longitude[0] : { value: "" };
    area_name = area_name.length > 0 ? area_name[0] : { value: "" };
    area_radius = area_radius.length > 0 ? area_radius[0] : { value: "" };
    zoom = zoom.length > 0 ? zoom[0] : { value: "" };

    return { area_latitude, area_longitude, area_radius, zoom, area_name };
  }
}
